/*
 * @Author: jiahuacui
 * @Date: 2018-08-09 14:31:10
 * @LastEditors: jiahuacui
 * @LastEditTime: 2018-08-08 14:31:10
 * @Description: 
 */
 <!-- 
  详情页 - 生产单产品信息
  props:
    id: 详情id
 -->
 <template>
    <div class="v-tabs product-list">
      <div class="content">
        <P class="bomdetail-title">成品</P>
        <el-table
          :data="finishedTableData"
          class="bomdetail-table"
          border
          highlight-current-row
          style="width: 100%">
          <el-table-column
            v-for="(h,index) in finishedExplains"
            :label="h.attrName"
            :prop="h.attr"
            :key="h.attr"
            show-overflow-tooltip
            min-width="100">
            <template slot-scope="scope">
              <template v-if="[5,6,8,10].indexOf(h.fieldType) === -1">
                <span>{{scope.row.result[index].attrValue || '--'}}</span>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <div class="table-foot">
          <span class="item">已入库：{{others.alreadyInstock}};</span>
          <span class="item warning">待入库：{{others.delayInstock}};</span>
        </div>
        <P class="bomdetail-title">物料</P>
        <el-table
          :data="materialTableData"
          class="bomdetail-table"
          border
          highlight-current-row
          style="width: 100%">
          <el-table-column
            v-for="(h,index) in materialExplains"
            :label="h.attrName"
            :prop="h.attr"
            :key="h.attr"
            show-overflow-tooltip
            min-width="100">
            <template slot-scope="scope">
              <template v-if="h.attr==='warehouse'">
                <span>{{scope.row.result[index].attrValue.value}}</span>
              </template>
              <template v-else-if="h.attr==='attritionRate'">
                <span>{{scope.row.result[index].attrValue}}</span>
              </template>
              <template v-else-if="[5,6,8,10].indexOf(h.fieldType) === -1">
                <span>{{scope.row.result[index].attrValue || '--'}}</span>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
 </template>
 <script>
import * as api from 'src/api'

export default {
  created () {
    this.getList()
  },
  props: {
    id: {
      type: Number
    }
  },
  data () {
    return {
      finishedExplains: [],
      finishedTableData: [],
      materialExplains: [],
      materialTableData: [],
      others: {}
    }
  },
  methods: {
    getList () {
      let url = '/productionOrder/productionOrderProductList.html'
      let params = {
        productionOrderId: this.id
      }
      api.post(url, params, (data) => {
        this.finishedExplains = data.finishedProduct.explains
        this.finishedTableData = data.finishedProduct.productList
        this.materialExplains = data.materiel.explains
        this.materialTableData = data.materiel.productList
        this.others = data.others
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .product-list {
    .bomdetail-title {
      padding-bottom: 15px;
    }
    .table-foot {
      .warning {color: #ff7c35;}
      margin-bottom: 15px;
    }
  }
</style>


// WEBPACK FOOTER //
// product-list.vue?5c5f372a